
import React, { useState, useRef, useEffect,useContext } from "react";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { BASE_URL, raiseConcern } from "../../api/api";
import { AuthContext } from "../../context/AuthContext";
import Swal from "sweetalert2";

const Raise_concern_popup = ({ show, handleClose,ascName }) => {
  const fileInputRef = useRef(null);
     const { user } = useContext(AuthContext);
  
  const location = useLocation();
  const aaNumber = location.state?.aaNumber;
useEffect(() => {
  if (show) {
    const now = new Date();
    const formattedDate = now.toISOString().split("T")[0]; // yyyy-mm-dd
    const formattedTime = now.toTimeString().split(" ")[0].slice(0, 5); // hh:mm

    setFormData((prev) => ({
      ...prev,
      date: formattedDate,
      time: formattedTime,
    }));
  }
}, [show]);

  const [formData, setFormData] = useState({
    date: "",
  time: "",
    remarkCategory: "",
    remarkIssue: "",
    file: null,
  });


  const [errors, setErrors] = useState({
    date: "",
    time: "",
    remarkCategory: "",
    remarkIssue: "",
    file: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  // Reset form when modal is closed
  useEffect(() => {
    if (!show) {
      setFormData({
        date: "",
        time: "",
        remarkCategory: "",
        remarkIssue: "",
        file: null,
      });
      setErrors({
        date: "",
        time: "",
        remarkCategory: "",
        remarkIssue: "",
        file: "",
      });
    }
  }, [show]);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    validateFile(droppedFile);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    validateFile(selectedFile);
  };

  const validateFile = (file) => {
    let error = "";
    if (file) {
      // Check file type (allow images and PDFs)
      const validTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "application/pdf",
      ];
      // if (!validTypes.includes(file.type)) {
      //   error = "Only images (JPEG, PNG, GIF) and PDF files are allowed";
      // }
      // Check file size (5MB max)
       if (file.size > 5 * 1024 * 1024) {
        error = "File size must be less than 5MB";
      }
    }

    setErrors((prev) => ({ ...prev, file: error }));
    setFormData((prev) => ({ ...prev, file: error ? null : file }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!formData.date) {
      newErrors.date = "Date is required";
      isValid = false;
    }

    if (!formData.time) {
      newErrors.time = "Time is required";
      isValid = false;
    }

    // if (!formData.remarkCategory) {
    //   newErrors.remarkCategory = "Remarks category is required";
    //   isValid = false;
    // }

    if (!formData.remarkIssue) {
      newErrors.remarkIssue = "Remarks is required";
      isValid = false;
    } else if (formData.remarkIssue.length < 10) {
      newErrors.remarkIssue = "Remarks must be at least 10 characters";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) {
    return;
  }

  setIsSubmitting(true);

  try {
    const formDataToSend = new FormData();
    formDataToSend.append("aano", aaNumber);
    formDataToSend.append("remark", formData.remarkIssue || "");
    formDataToSend.append("remarkFile", formData.file);
    formDataToSend.append("RemarkBy", user.role);
    formDataToSend.append("BillingType", "billing");
    formDataToSend.append("Document", null);

    const response = await fetch(`${BASE_URL}/UpdateClaimRemarks`, {
      method: "POST",
      body: formDataToSend,
    });

    const result = await response.json();

    if (response.ok) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: result.message || "Remark updated successfully!",
        confirmButtonColor: "#3085d6",
      }).then(() => {
        handleClose();
        window.location.reload();
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: result.message || "Failed to update remark.",
        confirmButtonColor: "#d33",
      });
    }
  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Upload Failed",
      text: "Failed to raise concern. Please upload the required documents.",
      confirmButtonColor: "#d33",
    });
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="hold_reason_modal raise_concern_popup"
      backdrop="static"
    >
      <Modal.Header
        style={{ backgroundColor: "#e6f0ff" }}
        closeButton
        className="hold_popup_header"
      >
        <Modal.Title>Add Remark</Modal.Title>
      </Modal.Header>
      <Modal.Body className="hold_popup_body">
        <form className="raise_concern_popup_form" onSubmit={handleSubmit}>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="mb-0 fw-bold" style={{textDecoration:"underline"}}>Vendor Name : {ascName}</h5>
            <div className="bg-light border px-3 py-1 rounded-3 text-muted">
              AA no - <strong>{aaNumber}</strong>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="inputDate" className="form-label fw-semibold">
                Date
              </label>
              <input
                type="date"
                id="inputDate"
                name="date"
                className={`form-control py-3 ${
                  errors.date ? "is-invalid" : ""
                }`}
                value={formData.date}
                readOnly
              />
              {errors.date && (
                <div className="invalid-feedback">{errors.date}</div>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="inputTime" className="form-label fw-semibold">
                Time
              </label>
              <input
                type="time"
                id="inputTime"
                name="time"
                className={`form-control py-3 ${
                  errors.time ? "is-invalid" : ""
                }`}
                value={formData.time}
                readOnly
              />
              {errors.time && (
                <div className="invalid-feedback">{errors.time}</div>
              )}
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="textareaIssue" className="form-label fw-semibold">
              Remarks
            </label>
            <textarea
              id="textareaIssue"
              name="remarkIssue"
              className={`form-control rounded-2 ${
                errors.remarkIssue ? "is-invalid" : ""
              }`}
              rows="4"
              placeholder="Enter your issues"
              value={formData.remarkIssue}
              onChange={handleChange}
            ></textarea>
            {errors.remarkIssue && (
              <div className="invalid-feedback">{errors.remarkIssue}</div>
            )}
          </div>

          <div
            onClick={handleClick}
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
            className="text-center p-4"
            style={{
              border: `1px dashed ${errors.file ? "#dc3545" : "#ccc"}`,
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            <input
              type="file"
              ref={fileInputRef}
              className="d-none"
              onChange={handleFileChange}
              accept="image/*,.pdf"
            />
            <p className="mt-2 mb-0 text-muted raise_drag">
              Drag and drop or <span className="text-primary">browse</span> your
              files
            </p>
            {formData.file && (
              <p className="mt-2 text-success">
                File selected: {formData.file.name}
              </p>
            )}
            {errors.file && <p className="mt-2 text-danger">{errors.file}</p>}
          </div>

          <div className="text-center mt-4">
            <button
              type="submit"
              className="btn btn-primary px-5 py-2"
              style={{
                backgroundColor: "#8000d7",
                border: "none",
                fontWeight: "500",
                fontSize: "16px",
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Processing..." : "Submit"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default Raise_concern_popup;
